/* unplugin-vue-components disabled */import script from "./Xiaomi.vue?vue&type=script&setup=true&lang=ts"
export * from "./Xiaomi.vue?vue&type=script&setup=true&lang=ts"

import "./Xiaomi.vue?vue&type=style&index=0&id=b410f3e6&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b410f3e6"]])

export default __exports__